export default __webpack_public_path__ + "06b007355f79104fd73e004000db80bc.png";